import { render, staticRenderFns } from "./OrderPlacing.vue?vue&type=template&id=9c6b4a4a&scoped=true"
import script from "./OrderPlacing.vue?vue&type=script&lang=js"
export * from "./OrderPlacing.vue?vue&type=script&lang=js"
import style0 from "./OrderPlacing.vue?vue&type=style&index=0&id=9c6b4a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6b4a4a",
  null
  
)

export default component.exports